import { ManageCommon } from "./base-manager.abstract";

export abstract class DataSkriveManage extends ManageCommon {
  abstract init(payload?: any): void;
  abstract destroyLibrary(): void;
}
